import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { StylesProvider, ThemeProvider as JssThemeProvider } from '@mui/styles'

import { ReduxProvider } from '../../core/redux'
import { I18NProvider } from '../../core/i18n'
import { AjaxProvider } from '../../core/ajax'
import { Modal as ModalProvider } from '../../ui/modal'
import { BootstrapRouter } from '../routers/bootstrap.router'
import { OnServerDown } from '../onServerDown/onServerDown.component'
import OnCrash from '../onCrash/onCrash.component'
import { theme } from '../../core/theme/constants/theme'

export const BootstrapComponent = () => {
  return (
    <ReduxProvider>
      <StylesProvider>
        <JssThemeProvider theme={theme}>
          <MuiThemeProvider theme={theme}>
            <I18NProvider>
              <AjaxProvider>
                <OnServerDown>
                  <OnCrash>
                    <ModalProvider>
                      <BrowserRouter>
                        <BootstrapRouter />
                      </BrowserRouter>
                    </ModalProvider>
                  </OnCrash>
                </OnServerDown>
              </AjaxProvider>
              <ToastContainer limit={3} />
            </I18NProvider>
          </MuiThemeProvider>
        </JssThemeProvider>
      </StylesProvider>
    </ReduxProvider>
  )
}
